export default __webpack_public_path__ + "static/Resolve-Bold-f64d9d49e77a29ea56187447860875f5.woff2";